import { excludeSpecialCharacters } from '../../../../../utils/validation'

export function getLastNameFieldNextValue(event) {
  const nextEvent = { ...event }

  nextEvent.target.value = excludeSpecialCharacters(event.target.value)

  return nextEvent
}
